/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Notes_TitleInputs */

const en_fc_dl_notes_title = /** @type {(inputs: Fc_Dl_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release notes`)
};

/**
* | output |
* | --- |
* | "Release notes" |
*
* @param {Fc_Dl_Notes_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_notes_title = /** @type {((inputs?: Fc_Dl_Notes_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Notes_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_notes_title(inputs)
});
export { fc_dl_notes_title as "fc.dl.notes.title" }